import Big from 'big.js';
import dayjs from 'dayjs';

const API_KEY = 'fca_live_Rb0EnaBKVzEruYtHOhaxZoH3shDoD16lL6BiMGwo'

let currentHistoricalExchangeRatesPromise: Record<string, Promise<any> | null> = {};
export default async function getExchangeRates(
  day: string,
  baseCurrency: string,
) {
  if (currentHistoricalExchangeRatesPromise[day]) {
    return currentHistoricalExchangeRatesPromise[day];
  }

  const cacheKey = `exchange_rates_${day}_${baseCurrency}`;
  const cachedData = localStorage.getItem(cacheKey);
  if (cachedData) {
    return JSON.parse(cachedData);
  }

  console.log('making historical exchange rates request for', day, baseCurrency);

  const params = new URLSearchParams();
  params.set('apikey', API_KEY);
  params.set('date', day);
  params.set('base_currency', baseCurrency);
  currentHistoricalExchangeRatesPromise[day] = fetch(`https://api.freecurrencyapi.com/v1/historical?${params.toString()}`)
    .then(response => response.json())
    .then(responseJson => {
      currentHistoricalExchangeRatesPromise[day] = null;
      localStorage.setItem(cacheKey, JSON.stringify(responseJson.data[day]));
      return responseJson.data[day];
    });
  return currentHistoricalExchangeRatesPromise[day];
}

let currentLatestExchangeRatesPromise: Promise<any> | null = null;
export async function getLatestExchangeRates(
  baseCurrency: string
) {
  if (currentLatestExchangeRatesPromise) {
    return currentLatestExchangeRatesPromise;
  }

  const currentDate = new Date().toISOString().split('T')[0];
  const cacheKey = `exchange_rates_${currentDate}_${baseCurrency}`;
  const cachedData = localStorage.getItem(cacheKey);
  if (cachedData) {
    return JSON.parse(cachedData);
  }
  console.log('making latest exchange rates request for', baseCurrency);

  const params = new URLSearchParams();
  params.set('apikey', API_KEY);
  params.set('base_currency', baseCurrency);
  currentLatestExchangeRatesPromise = fetch(`https://api.freecurrencyapi.com/v1/latest?${params.toString()}`)
    .then(response => response.json())
    .then(responseJson => {
      currentLatestExchangeRatesPromise = null;
      localStorage.setItem(cacheKey, JSON.stringify(responseJson.data));
      return responseJson.data;
    });
  return currentLatestExchangeRatesPromise;
}

export async function convertCurrency(
  amount: number | Big,
  fromCurrency: string,
  toCurrency: string,
) {
  if (fromCurrency === toCurrency) {
    return amount instanceof Big ? amount : new Big(amount);
  }
  const exchangeRates = await getLatestExchangeRates(fromCurrency);
  return new Big(amount).times(exchangeRates[toCurrency]);
}

export async function convertCurrencyAtDate(
  amount: number | Big,
  fromCurrency: string,
  toCurrency: string,
  date: dayjs.Dayjs | string | Date,
) {
  const day = dayjs(date).format('YYYY-MM-DD');
  const exchangeRates = await getExchangeRates(day, fromCurrency);
  if (!exchangeRates[toCurrency]) {
    throw new Error(`Exchange rate not found for ${fromCurrency} to ${toCurrency} on ${day}`);
  }
  return new Big(amount).times(exchangeRates[toCurrency]);
}